
import { Form } from 'element-ui'

export default {
  extends: Form,
}
